<!-- Bar Chart -->
<template>
	<ECharts :options="reformatOptions" style="width:100%; height:300px" />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import ChartHelper from '../../../../mixins/ChartHelper'

export default {
	name: 'SingleBar',
	props: {
		options: {
			type: Object,
			default: () => {
				return {}
			}
		},
		color: {
			type: String,
			default: '#ffe552'
		},
		showTitle: {
			type: Boolean,
			default: true
		},
		titleText: {
			type: String,
			default: ''
		},
		showLegend: {
			type: Boolean,
			default: true
		},
		xShowSplitLine: {
			type: Boolean,
			default: true
		},
		xAxisTick: {
			type: Boolean,
			default: true
		},
		xAxisLine: {
			type: Boolean,
			default: true
		},
		xData: {
			type: Array,
			default: () => {
				return []
			}
		},
		yShowSplitLine: {
			type: Boolean,
			default: true
		},
		yAxisTick: {
			type: Boolean,
			default: true
		},
		yAxisLabel: {
			type: Boolean,
			default: true
		},
		yAxisLine: {
			type: Boolean,
			default: true
		},
		yData: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	components: {
		ECharts
	},
	mixins: [ChartHelper],
	computed: {
		reformatOptions() {
			let barWidth = this.barWidth(this.xData.length)

			let dataChart = {
				grid: {
					left: '2%',
					right: '4%',
					bottom: '3%',
					top: '70',
					containLabel: true
				},
				legend: {
					// orient: 'vertical'
					top: 35,
					show: this.showLegend
				},
				title: {
					show: this.showTitle,
					text: this.titleText,
					textStyle: {
						fontSize: 24,
						height: 0
					}
				},
				tooltip: {
					show: true
				},
				color: this.color,
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: this.xData,
					splitLine: {
						show: this.xShowSplitLine,
						lineStyle: {
							color: '#CCCCCC'
						}
					},
					axisTick: {
						show: this.xAxisTick
					},
					axisLine: {
						show: this.xAxisLine,
						lineStyle: {
							color: '#2C2C2C'
						}
					}
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						show: this.yAxisLabel
					},
					axisTick: {
						show: this.yAxisTick
					},
					splitLine: {
						show: this.yShowSplitLine,
						lineStyle: {
							color: '#CCCCCC'
						}
					},
					axisLine: {
						show: this.yAxisLine,
						lineStyle: {
							color: '#2C2C2C'
						}
					}
				},
				series: [
					{
						name: this.titleText,
						type: 'bar',
						data: this.yData,
						barWidth
					}
				]
			}

			return dataChart
		}
	}
}
</script>
